import {clone} from 'ramda'
export const initialState = {
  questions: []
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnQuestionSaved':
      return onQuestionSaved(state, action);
    case 'OnQuestionDetailChanged':
      return onQuestionDetailChanged(state, action);
    case 'OnQuestionAdded':
      return onQuestionAdded(state, action);
    case 'OnQuestionDeleted':
      return onQuestionDeleted(state, action);
    case 'OnQuestionDetailAdded':
      return onQuestionDetailAdded(state, action);
    case 'OnQuestionDetailDeleted':
      return onQuestionDetailDeleted(state, action);
    case 'OnQuestionExpanded':
      return onQuestionExpanded(state, action);
    case 'OnDetailsPropertyChanged':
      return onDetailsPropertyChanged(state, action);

    default:
      return state;
  }
}

function onInitState(state, action) {
  const { data } = action;
  return {
    ...state,
    questions: data.map(item => {
      return { ...item, changed: false, isExpanded: false };
    })
  };
}

function onQuestionSaved(state, action) {
  let index = 0;
  index = state?.questions.findIndex(x => x.questionId === action.data.id);
  if (index === -1) index = action.data.idx;
  return {
    ...state,
    questions: Object.assign([...state.questions], {
      [index]: {
        ...state.questions[index],
        questionId: action.data.id,
        changed: false,
        isExpanded: true
      }
    })
  };
}

function onQuestionDetailChanged(state, action) {
  const { propName, propValue, questionIndex, questionDetailIndex } = action;
  const newQuestionValues = clone(state.questions[questionIndex].questionDetails);

  if (action.propName === 'isDefault' && action.propValue === true) {
    var _questionDetails = Object.assign([...newQuestionValues], {
      [questionDetailIndex]: {
        ...newQuestionValues[questionDetailIndex],
        [propName]: propValue
      }
    });

    _questionDetails.forEach(q => {
      if (q.questionDetailCode !== _questionDetails[questionDetailIndex].questionDetailCode) q.isDefault = false;
    });

    return {
      ...state,
      questions: Object.assign([...state.questions], {
        [questionIndex]: {
          ...state.questions[questionIndex],
          changed: true,
          questionDetails: _questionDetails
        }
      })
    };
  } else {
    return {
      ...state,
      questions: Object.assign([...state.questions], {
        [questionIndex]: {
          ...state.questions[questionIndex],
          changed: true,
          questionDetails: Object.assign([...newQuestionValues], {
            [questionDetailIndex]: {
              ...newQuestionValues[questionDetailIndex],
              [propName]: propValue
            }
          })
        }
      })
    };
  }
}

function onQuestionAdded(state, action) {
  const { index, questionnaireId } = action;
  const question = {
    questionId: null,
    siteId: 0,
    questionCode: '',
    questionName: '',
    questionTypeId: null,
    orderNo:
      state && state.questions && state.questions.length > 0
        ? Math.max.apply(
            Math,
            state.questions.map(item => item.orderNo)
          ) + 1
        : 1,
    readOnly: false,
    chQuestionId: null,
    chQuestionSiteId: null,
    generationId: null,
    mandatory: false,
    formula: '',
    numericPrecision: null,
    questionnaireId: questionnaireId,
    questionDetails: [],
    changed: true,
    isExpanded: true
  };
  const newQuestions = Object.assign([...state.questions]);
  if (index) newQuestions.splice(index, 0, { ...question, changed: true });
  else newQuestions.push({ ...question, changed: true });
  return {
    ...state,
    questions: newQuestions
  };
}

function onQuestionDeleted(state, action) {
  const { index } = action;
  const newQuestions = Object.assign([...state.questions]);
  newQuestions.splice(index, 1);
  return {
    ...state,
    questions: [...newQuestions]
  };
}

function onQuestionDetailAdded(state, action) {
  const { index, questionId } = action;
  const questionDetail = {
    questionDetailId: null,
    questionDetailCode: '',
    questionValue: '',
    isDefault: false,
    questionId: questionId
  };
  const newQuestionDetails = Object.assign([...state.questions[index].questionDetails]);
  newQuestionDetails.push({ ...questionDetail });

  return {
    ...state,
    questions: Object.assign([...state.questions], {
      [index]: {
        ...state.questions[index],
        changed: true,
        questionDetails: newQuestionDetails
      }
    })
  };
}

function onQuestionDetailDeleted(state, action) {
  const { index, questionDetailIndex } = action;
  const newQuestionDetails = Object.assign([...state.questions[index].questionDetails]);
  newQuestionDetails.splice(questionDetailIndex, 1);
  return {
    ...state,
    questions: Object.assign([...state.questions], {
      [index]: {
        ...state.questions[index],
        changed: true,
        questionDetails: newQuestionDetails
      }
    })
  };
}

const onQuestionExpanded = (state, action) => {
  const { index, isExpanded } = action;
  return {
    ...state,
    questions: Object.assign([...state.questions], {
      [index]: {
        ...state.questions[index],
        isExpanded: isExpanded
      }
    })
  };
};

function onDetailsPropertyChanged(state, action) {
  const { detailPropertyName, detailValue, index } = action;
  return {
    ...state,
    questions: Object.assign([...state.questions], {
      [index]: {
        ...state.questions[index],
        [detailPropertyName]: detailValue,
        changed: true
      }
    })
  };
}
